import FilterIcon from "Assets/Icons/FilterIcon";
import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

function ScheduleViewHeader({
  dateHandler,
  selectedDateRange,
  filterState,
  isPaneOpen,
  setisPaneOpen,
  setFilterState,
}: any) {
  const navigate = useNavigate();
  const { screen }: any = useWindowSize();
  const handleClearAllFilter = () => {
    setFilterState(null);
  };
  const filterLength = filterState
    ? Object.values(filterState).filter((ele) => ele != null).length
    : 0;
  return (
    <>
      <div>
        <Row className="mb-0">
          <Col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            className="pl-2 d-flex justify-content-between w-100"
          >
            <div className="d-flex flex-row align-items-center w-100">
              {["xxl", "xl", "lg"].includes(screen) && (
                <LeftArrow
                  className={"cursorHoverCSS mr-3 ml-1"}
                  onClick={() => {
                    navigate("/admin/dashboard");
                  }}
                />
              )}
              <Typography
                variant={["xxl", "xl", "lg"].includes(screen) ? "h4" : "h6"}
                color="black"
              >
                My Schedule
              </Typography>
              {!["xxl", "xl", "lg"].includes(screen) && (
                <div className="pl-2">
                  <Button
                    className="plannerButtonStyle"
                    color="aeslPrimary"
                    size="sm"
                    outline
                    onClick={dateHandler}
                  >
                    {selectedDateRange ? selectedDateRange : "Date"}
                  </Button>
                </div>
              )}
            </div>
            {["md", "xs", "sm"].includes(screen) && (
              <div className="d-flex justify-content-between align-items-center">
                {filterLength != 0 ? (
                  <div className="d-flex">
                    <div
                      className="clearAllButtonStyle cursorHoverCSS"
                      onClick={() => {
                        handleClearAllFilter();
                      }}
                    >
                      Clear all
                    </div>
                    <FilterIcon
                      onClick={() => {
                        setisPaneOpen(!isPaneOpen);
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center"
                    onClick={() => {
                      setisPaneOpen(!isPaneOpen);
                    }}
                  >
                    <span className="filterSpan">Filter</span>
                    <FilterIcon />
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}
export default ScheduleViewHeader;
